import { Pipe, PipeTransform } from '@angular/core';
import { Language } from '../../interfaces/language.interface';

const LANGUAGE_MAP = new Map<string, Language>(
  [
    { code: 'en', locale: 'en_US', english: 'English', native: 'English', localised: 'English' },
    { code: 'fr', locale: 'fr_FR', english: 'French', native: 'Français', localised: 'French' },
    { code: 'de', locale: 'de_DE', english: 'German', native: 'Deutsch', localised: 'German' },
    { code: 'es', locale: 'es_ES', english: 'Spanish', native: 'Español', localised: 'Spanish' },
    { code: 'it', locale: 'it_IT', english: 'Italian', native: 'Italiano', localised: 'Italian' },
  ].map((lang) => [lang.code, lang])
);

@Pipe({
  name: 'languageDisplay',
  standalone: true,
})
export class LanguageDisplayPipe implements PipeTransform {
  transform(languageCode: string | null | undefined): string {
    if (!languageCode) {
      return '';
    }

    const language = LANGUAGE_MAP.get(languageCode);
    if (!language) {
      return languageCode;
    }

    return `${language.native} (${language.english})`;
  }
}
